export interface ApporveBalanceFormValues {
  amount: string
}

export enum ClaimBalanceSwitchTypes {
  Deposit = 'Deposit',
  Claim = 'Withdraw treasure'
}
